(ns minorodata.components.file-ingest.confirmation
  (:require [clojure.string]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.components.spinner.core :as c.spinner]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.alert :refer [alert alert-title]]
            [ui.button :refer [button]]
            [ui.card :refer [card]]))


(defn confirmation-render
  [{:keys [ingesting? result ingest-result total table-name reason]}]
  [:<>
   [card {:class "p-3"}
    (if ingesting?
      [:div {:class "flex min-h-[200px] items-center justify-center text-kleene-text-secondary"}
       [c.spinner/with-text {:text "Loading..."}]]

      [:div
       (when (and ingest-result (not ingesting?))
         (if (= result :success)
           [alert {:variant :success}
            [alert-title
             "Success! "
             (str "Inserted " total " rows to table " table-name)]]

           [alert {:variant :error}
            [alert-title
             "Failed to import data! "
             (when-not (clojure.string/blank? reason)
               (str "Reason: " reason))]]))])]

   (when (and ingest-result (not ingesting?) (= result :success))
     [:div {:class "flex justify-end gap-2 mt-4"}
      [button {:variant  :secondary
               :data-cy  :file-ingest-import-another
               :on-click #(dispatch [:file-ingest.events/set-wizard-step :upload-file])}
       "Import another file"]])])


(defn confirmation []
  (let [ingest-result (re-posh/subscribe [:ingest-result/pull])
        ingesting?    (re-posh/subscribe [:mold-http/loading? :file-ingest.api/import-data])
        table-params  (re-posh/subscribe [:ingest-table-params/pull])]
    (reagent/create-class
      {:display-name
       "confirmation"

       :constructor
       (fn []
         (dispatch [:file-ingest.api/import-data]))

       :component-will-unmount
       (fn []
         (dispatch [:ingest-data/delete])
         (dispatch [:ingest-result/delete])
         (dispatch [:ingest-selected-columns/delete]))

       :render
       (fn []
         (let [{:ingest-result/keys [result total reason]} @ingest-result
               {:ingest-table-params/keys [table-name]}    @table-params]
           [confirmation-render
            {:ingesting?    @ingesting?
             :result        result
             :ingest-result @ingest-result
             :total         total
             :table-name    table-name
             :reason        reason}]))})))
